
import Echo from 'laravel-echo'
window.io = require('socket.io-client');
import { ENV_JACKPOT_SOCKET_URL } from '../../plugins/replaces'

const state = {
    connection: false,
    debug: true,
    jackpotData:[],
    listening: true,
    echo: new Echo({
        //broadcaster: 'socket.io',
        host: ENV_JACKPOT_SOCKET_URL,
        encrypted: true,
        disableStats: true
    }),
    public: [
        {
            channel: '*',
            event: '*',
            dispatch: 'jackpotUpdate',
            mutation: null
        }
    ],
    private: [
        
    ]
}
const getters = {
    jackpotData(state) {
        return state.jackpotData
    },
    public(state) {
        return state.public
    },
    private(state) {
        return state.private
    },
    echo(state) {
        return state.echo
    },
    debug(){
        return state.debug
    }
}
const mutations = {
    LISTENING (state, payLoad) {
        state.listening = payLoad;
    },
    SET_JACKPOT_DATA (state, payload) {
        state.jackpotData = payload;
    },
}
const actions = {
    jackpotUpdate: ({ commit, getters, rootState, rootGetters }, payload) => {
    },
    initChannels ({commit, dispatch, getters, rootGetters}) {
        if(getters.debug)
        {
            //console.log('Initializing Feed channels')
        }


        this.connection = new WebSocket(ENV_JACKPOT_SOCKET_URL)


        this.connection.onmessage = function(event) {
            var data = JSON.parse(event.data)

            commit('SET_JACKPOT_DATA', data)
        }
        setTimeout(() => {
            var message = '{"id":1, "currency" : "TRY"}'
            console.log(this.connection);
            this.connection.send(message);
        }, 2000);






        commit('LISTENING', false)
        //getters.echo.disconnect();


        //console.log(getters.echo)

        //getters.echo.connect();

        /* PUBLIC CHANNELS */

        /*
        getters.echo.channel('*')
        .listen('*', payload => {
            console.log(payload)
        })
 */
        /* PUBLIC CHANNELS */


        commit('LISTENING', true)
    }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}